export default __webpack_public_path__ + "static/media/Bluebox-light.98dfe80c.png";